import { Accordion, Button, Popover } from '@mantine/core';
import { IconCode, IconX } from '@tabler/icons-react';
import TestCard from '../test/TestCard';
import TestSearch from '../test/TestSearch';
import type { SuiteForm } from './form';

export function SetupTeardownSection({ form }: { form: SuiteForm }) {
  return (
    <Accordion.Item value="setup-teardown">
      <Accordion.Control icon={<IconCode size={14} />}>Setup/Teardown</Accordion.Control>
      <Accordion.Panel>
        <div className="grid grid-cols-2 gap-4 xl:gap-x-10">
          <div className="flex flex-1 items-center gap-2">
            <div className="min-w-max">Setup: </div>
            {form.values.setupTestId ?
              <div className="flex w-full flex-row items-center gap-2">
                <TestCard testId={form.values.setupTestId} />
                <IconX
                  className="cursor-pointer"
                  size={20}
                  color="red"
                  onClick={() => form.setFieldValue('setupTestId', '')}
                />
              </div>
            : <Popover
                position="bottom-start"
                withArrow
                shadow="md"
              >
                <Popover.Target>
                  <Button
                    size="xs"
                    variant="outline"
                  >
                    Add Setup Test
                  </Button>
                </Popover.Target>
                <Popover.Dropdown style={{ width: '400px' }}>
                  <TestSearch
                    onClick={(testId) => {
                      form.setFieldValue('setupTestId', testId);
                    }}
                  />
                </Popover.Dropdown>
              </Popover>
            }
          </div>
          <div className="flex flex-1 items-center gap-2">
            <div className="min-w-max">Teardown: </div>
            {form.values.teardownTestId ?
              <div className="flex w-full flex-row items-center gap-2">
                <TestCard testId={form.values.teardownTestId} />
                <IconX
                  className="cursor-pointer"
                  size={20}
                  color="red"
                  onClick={() => form.setFieldValue('teardownTestId', '')}
                />
              </div>
            : <Popover
                position="bottom-start"
                withArrow
                shadow="md"
              >
                <Popover.Target>
                  <Button
                    size="xs"
                    variant="outline"
                  >
                    Add Teardown Test
                  </Button>
                </Popover.Target>
                <Popover.Dropdown style={{ width: '400px' }}>
                  <TestSearch
                    onClick={(testId) => {
                      form.setFieldValue('teardownTestId', testId);
                    }}
                  />
                </Popover.Dropdown>
              </Popover>
            }
          </div>

          <div className="flex flex-1 items-center gap-2">
            <div className="min-w-max">Before Each: </div>
            {form.values.beforeEachTestId ?
              <div className="flex w-full flex-row items-center gap-2">
                <TestCard testId={form.values.beforeEachTestId} />
                <IconX
                  className="cursor-pointer"
                  size={20}
                  color="red"
                  onClick={() => form.setFieldValue('beforeEachTestId', '')}
                />
              </div>
            : <Popover
                position="bottom-start"
                withArrow
                shadow="md"
              >
                <Popover.Target>
                  <Button
                    size="xs"
                    variant="outline"
                  >
                    Add Before Each Test
                  </Button>
                </Popover.Target>
                <Popover.Dropdown style={{ width: '400px' }}>
                  <TestSearch
                    onClick={(testId) => {
                      form.setFieldValue('beforeEachTestId', testId);
                    }}
                  />
                </Popover.Dropdown>
              </Popover>
            }
          </div>
          <div className="flex flex-1 items-center gap-2">
            <div className="min-w-max">After Each: </div>
            {form.values.afterEachTestId ?
              <div className="flex w-full flex-row items-center gap-2">
                <TestCard testId={form.values.afterEachTestId} />
                <IconX
                  className="cursor-pointer"
                  size={20}
                  color="red"
                  onClick={() => form.setFieldValue('afterEachTestId', '')}
                />
              </div>
            : <Popover
                position="bottom-start"
                withArrow
                shadow="md"
              >
                <Popover.Target>
                  <Button
                    size="xs"
                    variant="outline"
                  >
                    Add After Each Test
                  </Button>
                </Popover.Target>
                <Popover.Dropdown style={{ width: '400px' }}>
                  <TestSearch
                    onClick={(testId) => {
                      form.setFieldValue('afterEachTestId', testId);
                    }}
                  />
                </Popover.Dropdown>
              </Popover>
            }
          </div>
        </div>
      </Accordion.Panel>
    </Accordion.Item>
  );
}
